import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  getPracticasDenunciaOrigen,
  getTiposObservaciones,
  postPracticasAutorizadasDenuncia,
} from "../../../../actions/autorizaciones/Autorizaciones";
import { getZonasEfector } from "../../../../actions/contrataciones/contratacionesCartilla";

import { AutorizacionesPractica } from "../../Ingreso/AutorizacionesPractica";
import {
  AUTORIZACIONES_PRACTICAS_ESTADOS,
  AUTORIZACIONES_SOLICITUDES_ESTADOS,
  PRACTICA_APERTURA_DENUNCIA_INTERNACION,
  PRACTICA_CIERRE_DENUNCIA_INTERNACION,
} from "../../../../utils/constants";
import { ModalObservaciones } from './ModalObservaciones';
import { Button } from '@material-ui/core';
import { startAlerta } from '../../../../actions/ui/alertas';

export const PracticasDenunciaMenu = (props) => {
  const dispatch = useDispatch();

  const { practicas = [], solicitudSeleccionada = {} } = useSelector((state) => state.autorizaciones);

  const [openModalCierreDenuncia, setOpenModalCierreDenuncia] = useState(false);

  useEffect(() => {
    if (solicitudSeleccionada.idSolicitud) {
      dispatch(
        getPracticasDenunciaOrigen(
          solicitudSeleccionada.idSolicitud, 
          true, 
          props.filtros?.idEstadoSolicitud,
          props.filtros?.idBandeja
        )
      );
    }
  }, [props.pendientes]);

  useEffect(() => {
    dispatch(getTiposObservaciones(true));
    dispatch(getZonasEfector());
  }, []);

  const onClickPracticasHandler = () => {
    const practicasFormateadas = practicas.filter(s => s.idCodNom !== PRACTICA_CIERRE_DENUNCIA_INTERNACION.ID_COD_NOM
      && s.idCodNom !== PRACTICA_APERTURA_DENUNCIA_INTERNACION.ID_COD_NOM
      && !s.idSolicitudDenunciaInternacion
    ).map((practica) => {
      const materialesFormateados = [];
      // const materialesFormateados = practica.materiales?.map((material) => {
      //   return {
      //     idMaterial: material.idMaterial,
      //     idEstadoMaterial: material.idEstadoMaterial,
      //     idEstadoCompraMaterial: material.idEstadoCompraMaterial,
      //   };
      // });
      const cantidadesFecha = practica.cantidadesFecha?.map((item) => {
        return {
          fecha: item.fecha,
          horario: item.horario,
          idEstadoPracticaCantFecha: item.idEstadoPracticaCantFecha
        };
      });

      return {
        materiales: materialesFormateados ? materialesFormateados : [],
        cantidadesFecha: cantidadesFecha ? cantidadesFecha : [],
        idEstadoPractica: practica.idEstadoPractica,
        idSolicitud: practica.idSolicitud,
        idCodNom: practica.idCodNom,
        periodos: [],
      };
    });

    if(practicasFormateadas.filter(s => s.idEstadoPractica === AUTORIZACIONES_PRACTICAS_ESTADOS.PENDIENTE).length > 0)
        return dispatch(
          startAlerta(
            `Para guardar los cambios todas las Prácticas deben tener un Estado.`,
            "error",
            "Error"
          )
        );
    
    dispatch(
      postPracticasAutorizadasDenuncia(
        { practicas: practicasFormateadas, idSolicitud: solicitudSeleccionada.idSolicitud },
      )
    );
  };

  return (
    <React.Fragment>
      {openModalCierreDenuncia && (
        <ModalObservaciones
          open={openModalCierreDenuncia}
          close={() => {
            setOpenModalCierreDenuncia(false);
          }}
          desdeIngresoSolicitud={props.desdeIngresoSolicitud}
          idSolicitud={solicitudSeleccionada.idSolicitud}
          onCloseModalAuditar={props.onCloseModalAuditar}
          titulo={'Cerrar Internación'}
          cierreInternacion={true}
          observacion={null}
          filtros={props.filtros}
        />
      )}
      {Array.isArray(practicas) &&
        practicas?.length > 0 &&
        practicas
          .filter(s => s.idCodNom !== PRACTICA_CIERRE_DENUNCIA_INTERNACION.ID_COD_NOM)
          .map((practica, index) => {
            return (
              <AutorizacionesPractica
                key={index}
                practica={practica}
                desdeAuditar={true}
                disabled={props.disabled}
                esDenunciaInternacion={props.esDenunciaInternacion}
                conInternacion={solicitudSeleccionada.conInternacion}
                idTipoSolicitud={solicitudSeleccionada.idTipoSolicitud}
                evaluarPracticasMateriales={null}
                permiteAgregarPracticaPeriodo={false}
                permisoIngresoInterDom={props.permisoIngresoInterDom}
                filtros={props.filtros}
              />
            );
          })}
      <div style={{ textAlign: "center", marginTop: "2.5rem" }}>
        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <Button
            onClick={onClickPracticasHandler}
            disabled={solicitudSeleccionada.fechaBaja || props.seguimiento}
            variant="contained"
            color="primary"
          >
            Guardar Cambios
          </Button>
          <Button
            onClick={() => setOpenModalCierreDenuncia(true)}
            disabled={(props.disabled 
              && solicitudSeleccionada.idEstadoSolicitud !== AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE) ||
            props.seguimiento}
            variant="contained"
            color="primary"
          >
            Cerrar Internación
          </Button>
        </div>
      </div>
    </React.Fragment>
  );
};
